/**
 * @generated SignedSource<<aaa80e418308853b63a6933c059e0f2e>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
type AgentConnectedDialog_organization$fragmentType = any;
export type AgentConnectedDialogRendererQuery$variables = {|
  slug: string,
|};
export type AgentConnectedDialogRendererQuery$data = {|
  +organization: ?{|
    +$fragmentSpreads: AgentConnectedDialog_organization$fragmentType,
  |},
|};
export type AgentConnectedDialogRendererQuery = {|
  response: AgentConnectedDialogRendererQuery$data,
  variables: AgentConnectedDialogRendererQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentConnectedDialogRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AgentConnectedDialog_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentConnectedDialogRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b2b58a6ddbd4e70343e2d46364d5cf27",
    "id": null,
    "metadata": {},
    "name": "AgentConnectedDialogRendererQuery",
    "operationKind": "query",
    "text": "query AgentConnectedDialogRendererQuery(\n  $slug: ID!\n) {\n  organization(slug: $slug) {\n    ...AgentConnectedDialog_organization\n    id\n  }\n}\n\nfragment AgentConnectedDialog_organization on Organization {\n  slug\n}\n"
  }
};
})();

(node/*: any*/).hash = "32b4bd709aa38010dc02139b79a37667";

module.exports = ((node/*: any*/)/*: Query<
  AgentConnectedDialogRendererQuery$variables,
  AgentConnectedDialogRendererQuery$data,
>*/);
